<template>
  <div>
    <h5 class="mb-3">Revise la información ingresada</h5>
    <b-row>
      <b-col cols="2">
        <p class="label">Nombre</p>
      </b-col>
      <b-col cols="10">
        <p>{{user.firstName}}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        <p class="label">Apellido</p>
      </b-col>
      <b-col cols="10">
        <p>{{user.lastName}}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        <p class="label">Correo</p>
      </b-col>
      <b-col cols="10">
        <p>{{user.email}}</p>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col cols="2">
        <p class="label">Vendedores</p>
      </b-col>
      <b-col cols="10">
        <div v-if="user.userType && user.userType !== 'ADMIN_USER'">
          <span v-if="user.organizations.length === 0" class="disclaimer">Todos los vendedores</span>
          <b-badge
            v-else
            class="badgeSeller mr-2 mb-2"
            v-for="seller in user.organizations"
            :key="seller.id"
            variant="secondary">
            {{ seller.name }}
          </b-badge>
        </div>
        <span v-else class="disclaimer">Al administrador marketplace se le asignaran todos los sellers</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        <p class="label">Tipo de usuario</p>
      </b-col>
      <b-col cols="10">
        <p>{{formatTypeUser(user.userType)}}</p>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col cols="2">
        <p class="label">Roles / Permisos</p>
      </b-col>
      <b-col cols="10" class="d-flex gap-2 w-100 justify-content-start align-items-center flex-wrap mb-5">
        <div v-for="role in user.roles" :key="role.id" class="mr-2 mb-2">
          <b-badge
            class="badgeSeller"
            variant="secondary"
            >
            {{formatRoleName(role.roleName)}}
          </b-badge>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: ['user', 'roles'],
  data () {
    return { }
  },
  methods: { 
    formatTypeUser(type) {
      switch (type) {
        case 'ADMIN_USER':
          return 'Administrador Marketplace'
        case 'LOGISTICS_ADMIN':
          return 'Administrador Logístico'
        case 'ORGANIZATION_ADMIN_USER':
          return 'Seller Administrador'
        case 'ORGANIZATION_STANDARD_USER':
          return 'Seller'
        case 'CATALOGER_USER':
          return 'Catalogador'
        default:
          return type
      }
    },
    formatRoleName (roleName) {
      switch (roleName) {
        case 'INVENTORY_USER':
          return 'Inventario'
        case 'CARRIERS_USER':
          return 'Transportadoras'
        case 'CATALOG_USER':
          return 'Catálogo'
        case 'ORDERS_USER':
          return 'Pedidos'
        case 'REPORTS_USER':
          return 'Reportes'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
  font-size: 16;
}
.badgeSeller {
  border-radius: 7px;
  padding: 10px;
}

.disclaimer {
    background-color: #f5f3f3;
    border-radius: 5px;
    margin-top: 20px;
    padding: 10px 25px;
    color: #777777;
    font-size: 14px;
  }
</style>